module.exports = __webpack_public_path__ + "static/cgo.e06355b5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/leadership/cgo.jpeg
// module id = 854
// module chunks = 137123289437543